import { fetch } from '@/common/js/fetch';
import { serverCourseUrl } from './api';
import { DEFAULT_COMPETITION_TYPE } from '@/common/constant/qz';

export function saveSchoolApplication(params) {
  return fetch(
    serverCourseUrl + 'v1/course/competition/school/application/launch',
    {
      competitionType: DEFAULT_COMPETITION_TYPE,
      ...params,
    },
    {
      method: 'POST',
    },
  );
}

/**
 * 获取学校申请状态
 */
export function getSchoolApplicationStatus() {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     // application: null, //代表未申请
  //     application: {
  //       // 0：已提交申请，待审核
  //       // 1：初审通过
  //       // 2：初审不通过
  //       // 3: 复审待审核
  //       // 4: 复审通过
  //       // 5: 复审不通过
  //       status: 1,
  //       id: 5,
  //       rejectReason: '',
  //     },
  //   },
  // });
  return fetch(
    serverCourseUrl + 'v1/course/competition/school/application/query', {
      competitionType: DEFAULT_COMPETITION_TYPE,
    }
  );
}

export function uploadApplicationUser(params) {
   return fetch(`${serverCourseUrl}v1/course/competition/school/application/user/upload`, {}, {
      method: 'POST',
      body: params,
   })
}